export function useMicrosoftAuth() {
  function signInWithRedirect() {
    window.location.href = `${process.env.GATSBY_GETFLOW_API_ENDPOINT}/auth/azure?return_to=${window.location.pathname}?client_id=${process.env.GATSBY_MICROSOFT_CLIENT_ID}&prompt=login&redirect_uri=${process.env.GATSBY_GETFLOW_API_ENDPOINT}/credentials/azure/public`
  }

  return { signInWithMicrosoft: signInWithRedirect }
}
